import { useEffect, useState } from 'react';
import { fetchSupplierGroups } from '../../models/suppliers/suppliersModel';

// Historical Sent suppliers records still use legacy tag labels. No send commands.
export function useSuppliers() {
  const [groups, setGroups] = useState([]), [groupsLoading, setGroupsLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    fetchSupplierGroups().then(value => { if (alive) setGroups(value); }).finally(() => { if (alive) setGroupsLoading(false); });
    return () => { alive = false; };
  }, []);
  return { groups, groupsLoading };
}
